import type React from 'react';

import { Alert } from '@change/ds-core-ui';

import { useI18n } from '@change-corgi/core-react/i18n';

import { usePageBanner } from './hooks/usePageBanner';

export const PageBanner: React.FC = () => {
	const {
		data: { message, severity },
		actions: { resetPageMessage },
	} = usePageBanner();

	const { translate } = useI18n();

	if (!message || !severity) {
		return null;
	}

	return (
		<Alert
			variant={severity}
			type="page"
			dismissButtonAriaLabel={translate('corgi.components.banner.close')}
			onDismissClick={resetPageMessage}
			data-testid="contributions-banner"
			data-qa="contributions-banner"
		>
			{message}
		</Alert>
	);
};
